import { UserSalutation } from '@/@types/userAccount';

export const validateSalutation = (salutation: UserSalutation) => Object.values(UserSalutation).includes(salutation);
